// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__m6mvv","container_video":"styles_container_video__rD8vE","video":"styles_video__+Ebue","container_content":"styles_container_content__dgPwz"};